document.addEventListener('DOMContentLoaded', () => {
    const d4HandleNutritions = () => {
        const heading = document.querySelector('.d4-nutrition-container .nutrition-heading');
        const btns = document.querySelectorAll('.d4-nutrition-container .d4-multi-nutrition-body .d4-entry-titles .d4-entry-btn');
        btns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const currentBtn = document.querySelector('.d4-nutrition-container .d4-multi-nutrition-body .d4-entry-titles .d4-entry-active-btn');
                const currentInfo = document.querySelector('.d4-nutrition-container .d4-multi-nutrition-body .d4-entry-info .d4-entry-active-info');
                const activeInfo = document.querySelector(`.d4-nutrition-container .d4-multi-nutrition-body .d4-entry-info .nutrition-body[data-entry="${e.target.dataset.entry}"]`);
                currentBtn.classList.remove('d4-entry-active-btn');
                currentBtn.style.background = 'rgb(234, 234, 234)';
                e.target.classList.add('d4-entry-active-btn');
                e.target.style.background = `${e.target.dataset.bg}`;
                heading.style.background = `${e.target.dataset.bg}`;
                currentInfo.classList.remove('d4-entry-active-info');
                activeInfo.classList.add('d4-entry-active-info');
            })
        })
    }

    d4HandleNutritions();
});